import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ToastHost } from './components/Toast';
import { AuthProvider } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { LoginPage } from './pages/LoginPage';

/**
 * Ruterne er tynde: alt bag login haandteres af skallen, der oversaetter mellem
 * URL og faner. Hver fane har en sti, saa et dybt link aabner den rigtige fane.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="*"
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      />
    </Routes>
  );
}

export function App() {
  return (
    <AuthProvider>
      <AppRoutes />
      <ToastHost />
    </AuthProvider>
  );
}

export default App;
